/**
 * Texts of the Sinistres screens (fiches 22736 / 22807 / 22740 / 22742 /
 * 22744 / 22746) — kept out of the JSX. Card labels and column labels live
 * in their declarative configs (`claims*Config.ts`); these are the page
 * chrome and toolbar strings.
 */

import type { StatusBadgeConfig } from '../shared/statusBadgeConfig';

/** Claim status (`ETAT`): two values only — « Ouvert » orange, « Clos » green (fiche 22736). */
export const CLAIM_STATUS_BADGE: StatusBadgeConfig = {
  entries: {
    OUVERT: { label: 'Ouvert', variant: 'warning' },
    CLOS: { label: 'Clos', variant: 'success' },
  },
  fallbackVariant: 'default',
};

export const CLAIMS_TEXT = {
  /** Toolbar search placeholder (22989 mockup) — sent as `q`. */
  searchPlaceholder: 'Rechercher par réf, circonstances, assuré…',
  /** Status filter label (also the select placeholder). */
  statusFilterLabel: 'Statut',
  /** « All statuses » option of the status select — no `etat` sent. */
  allStatuses: 'Tous statuts',
  /** Label of the charges Total row (fiche 22742). */
  totalRow: 'Total',
} as const;

/**
 * « {n} sinistres au total » — subtitle of « Mes sinistres » (VEOS total of
 * the current search / status).
 */
export function claimsCountSubtitle(count: number): string {
  return `${String(count)} ${count > 1 ? 'sinistres' : 'sinistre'} au total`;
}

/** Stable keys of the claim detail tabs. */
export type ClaimDetailTabKey = 'details' | 'intervenants' | 'charges' | 'documents' | 'pieces';

/** One tab of the claim detail page (declarative, stable `key`). */
export interface ClaimDetailTab {
  key: ClaimDetailTabKey;
  label: string;
}

/** The claim detail tabs, in design order (fiche 22807 and following). */
export const CLAIM_DETAIL_TABS: readonly ClaimDetailTab[] = [
  { key: 'details', label: 'Détails' },
  { key: 'intervenants', label: 'Intervenants' },
  { key: 'charges', label: 'Charges' },
  { key: 'documents', label: 'Documents' },
  { key: 'pieces', label: 'Pièces' },
];

/** Accessible label of the pending-pieces count badge of the « Pièces » tab. */
export function pendingPiecesTabBadgeLabel(count: number): string {
  return `${String(count)} ${count > 1 ? 'pièces' : 'pièce'} en attente`;
}
